// extracted by mini-css-extract-plugin
module.exports = {"container":"cart-quantity_container__BHPh2","input":"cart-quantity_input__JL33b","button":"cart-quantity_button__TJGLW","increase":"cart-quantity_increase__DAvC5"};